import { useTranslation } from 'react-i18next'
import { Button } from 'ui/button'
import {
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerDescription,
  DrawerFooter,
  DrawerHeader,
  DrawerTitle,
} from 'ui/drawer'

import { isInStandalone } from '~/utils/is-stand-alone'

type Props = {
  onOpenChange: (open: boolean) => void
  open: boolean
}

export const PushPermissionBlockedDrawer = ({ onOpenChange, open }: Props) => {
  const { t } = useTranslation()

  return (
    <Drawer onOpenChange={onOpenChange} open={open}>
      <DrawerContent>
        <div className="mx-auto w-full max-w-sm">
          <DrawerHeader>
            <DrawerTitle>{t('Notifications blocked')}</DrawerTitle>
            <DrawerDescription>
              {t('You previously denied notifications Change them in browser or system settings for this site')}
            </DrawerDescription>
          </DrawerHeader>
          {isInStandalone() && (
            <p className="px-4 pb-2 text-center text-sm text-muted-foreground">
              {t('If the app is installed you may need to reinstall it')}
            </p>
          )}
          <DrawerFooter className="p-4">
            <DrawerClose render={<Button variant="outline" />}>{t('Close')}</DrawerClose>
          </DrawerFooter>
        </div>
      </DrawerContent>
    </Drawer>
  )
}
